export default "__VITE_ASSET__B8c4zABe__"